import React, { useEffect, useState } from 'react';
import Button from '../../../components/common-components/button/Button';
import {
	ABHA_LANGUAGE_OPTIONS,
	ABHA_CONSENT_FORM_LANGUAGE_TEXT,
	CONSENT_POINTS,
	CONSENT_LINE_TEMPLATE,
} from './Constants';
import Checkbox from '../../../components/common-components/checkbox/Checkbox';
import SelectDropdown from '../../../components/common-components/selectDropdown';

const ConsentFormABHA = ({ close, onSubmit }) => {
	const [selectedLanguage, setSelectedLanguage] = useState({ label: 'English', value: 'English', code: 'en' });
	const [beneficiaryName, setBeneficiaryName] = useState('');
	const [checkedItems, setCheckedItems] = useState([]);

	const basePoints = CONSENT_POINTS[selectedLanguage.code] || CONSENT_POINTS['en'];
	const allPointsCount = basePoints.length + 1;

	useEffect(() => {
		setCheckedItems(Array(allPointsCount).fill(false));
	}, [selectedLanguage]);

	const isAllChecked = checkedItems.length === allPointsCount && checkedItems.every(Boolean);

	const handleCheckboxChange = (index, value) => {
		const updated = [...checkedItems];
		updated[index] = value;
		setCheckedItems(updated);
	};

	const renderFinalConsentLine = () => {
		return CONSENT_LINE_TEMPLATE[selectedLanguage.code] || CONSENT_LINE_TEMPLATE['en'];
	};

	return (
		<div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-60">
			<div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-4xl overflow-y-auto max-h-[90vh]">
				<div className="flex justify-between items-center border-b pb-4">
					<div>
						<h2 className="text-lg font-semibold">Ayushman Bharat Health Account</h2>
						<h3 className="text-lg font-semibold">Consent Form</h3>
					</div>
					<button onClick={close} className="text-gray-600 hover:text-black text-xl">
						✕
					</button>
				</div>

				<div className="flex flex-col gap-6">
					<div className="flex justify-end mt-2">
						<SelectDropdown
							label="Select Language"
							name="language"
							value={selectedLanguage}
							onChangeCb={setSelectedLanguage}
							options={ABHA_LANGUAGE_OPTIONS}
						/>
					</div>

					<p>
						{ABHA_CONSENT_FORM_LANGUAGE_TEXT[selectedLanguage.code] ||
							ABHA_CONSENT_FORM_LANGUAGE_TEXT['en']}
					</p>

					<div className="flex flex-col gap-4 mb-4">
						{/* Consent Checkboxes */}
						{basePoints.map((text, idx) => (
							<Checkbox
								key={idx}
								label={text}
								checked={checkedItems[idx]}
								onChangeCb={(val) => handleCheckboxChange(idx, val)}
							/>
						))}

						{/* Final Consent Line with Name */}
						<div className="flex items-center gap-2 font-bold">
							<Checkbox
								checked={checkedItems[allPointsCount - 1]}
								onChangeCb={(val) => handleCheckboxChange(allPointsCount - 1, val)}
								disabled={!beneficiaryName.trim()}
							/>
							<label className="text-sm flex items-center gap-1 flex-wrap">
								<span>{renderFinalConsentLine().before}</span>
								<div className="relative">
									<input
										type="text"
										placeholder="Your Name"
										value={beneficiaryName}
										onChange={(e) => setBeneficiaryName(e.target.value)}
										className="border-b border-gray-400 outline-none px-2 py-1 w-40"
									/>
									{beneficiaryName && <span className="absolute right-[-10px] top-1">,</span>}
								</div>
								<span>{renderFinalConsentLine().after}</span>
							</label>
						</div>
					</div>

					<div className="flex justify-end">
						<Button onClickCb={() => isAllChecked && onSubmit()} disabled={!isAllChecked} type="submit">
							Submit
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConsentFormABHA;
